import { IconDefinition } from "@fortawesome/fontawesome-common-types/index";

export class ListItem {
  name: string;
  prefix: string;
  icon: IconDefinition;
  image: string;
  colour: string;
}
